// @ts-check
/**
 * Checks whether tooltip is enabled
 * @param {ChartlosOptions} options - chartlos options
 * @returns {boolean} - whether tooltip is enabled
 */
export const isTooltipEnabled = (options) => {
  if (options.type === 'bar' && options.horizontalBarType !== 'normal') return false;
  return options.interactive && options.showTooltips;
}